import { Store, select } from '@ngrx/store';
import { AlertTypes } from './alert.actions';
import { AlertState, getAlert } from './alert.reducer';
import { tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertComponent } from './alert.component';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'mojo-alert-container',
  templateUrl: './alert.container.component.html',
})
export class AlertContainerComponent {
  alertTypes = AlertTypes;
  alert$: Observable<AlertState>;

  constructor(private store: Store<{}>, private snackBar: MatSnackBar) {
    this.alert$ = this.store.pipe(
      select(getAlert),
      tap(({ type, message }: AlertState) => {
        if (type !== AlertTypes.NONE) {
          this.snackBar.openFromComponent(AlertComponent, {
            data: {
              message,
              type,
            },
            duration: 6000,
            panelClass: type,
            verticalPosition: 'top',
          });
        }
      }),
    );
  }
}
